import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  wizardBlockCardClassName,
  wizardBlockShellClassName,
} from '../wizardBlockChrome';
import { Input } from '@/components/ui/input';
import { HelpLabel } from '@/features/guided-help';

export interface BasicInfoNameFieldProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  placeholder?: string;
  wrapInCard?: boolean;
  inputId?: string;
}

export function BasicInfoNameField({
  value,
  onChange,
  maxLength = 100,
  placeholder = 'Ej: Torneo de Verano 2026',
  wrapInCard = true,
  inputId = 'tournament-name',
}: BasicInfoNameFieldProps) {
  const field = (
    <div className="space-y-2" data-guide-id="wizard.basicInfo.name">
      <HelpLabel htmlFor={inputId} topicId="wizard.basicInfo.name">
        Nombre *
      </HelpLabel>
      <Input
        id={inputId}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
      />
      <p className="text-xs text-gray-500">
        {value.length}/{maxLength} caracteres
      </p>
    </div>
  );

  if (!wrapInCard) {
    return <div className={wizardBlockShellClassName}>{field}</div>;
  }

  return (
    <Card className={wizardBlockCardClassName}>
      <CardHeader>
        <CardTitle className="text-lg">Nombre del torneo</CardTitle>
      </CardHeader>
      <CardContent>{field}</CardContent>
    </Card>
  );
}
